import { AnyAaaaRecord } from "dns";
import React, { useEffect, useState } from "react";
import { Table } from 'rsuite';
const {Column,HeaderCell,Cell}=Table;
type attributes = {
  teams:any,
  
}
export const TeamDetails=(props:attributes)=>{

    return(
        <Table
        height={300}
      data={props.teams}
      onRowClick={data => {
      
      }}
    >
      <Column  flexGrow={300} align="center" >
        <HeaderCell>TEAM</HeaderCell>
        <Cell dataKey="TeamName" />
      </Column>

      <Column   flexGrow={100} >  
        <HeaderCell>SUBTEAM</HeaderCell>
        <Cell dataKey="SubTeamName" />
      </Column>

      <Column flexGrow={100} >
        <HeaderCell>PROCESS</HeaderCell>
        <Cell dataKey="Process" />
      </Column>

      <Column flexGrow={120}>
        <HeaderCell>ALLOCATION%</HeaderCell>
        <Cell dataKey="Allocation" />
      </Column>

      <Column flexGrow={120}>
        <HeaderCell>BUFFER%</HeaderCell>
        <Cell dataKey="Buffer" />
      </Column>
      
    </Table>
    )
}